import React from "react"
import { createContext } from "use-context-selector"
import { useAppContextState } from "app/@hooks"

const Context = createContext({})

const initialState = {
    isRunning: false,
    stepIndex: 0,
    steps: [],
    tourKey: null,
}

export function AppTourProvider({ children }) {
    const { state, updateState, replaceState, resetState } = useAppContextState(initialState)

    return <Context.Provider value={{ state, updateState, replaceState, resetState }}>
        {children}
    </Context.Provider>
}

export default Context
